<template>
  <header class="header">
    <div class="header-inner">
      <div class="header-inner--left">
        <a href="/" :class="{ active: active === 'home' }">Home</a>
        <!-- <a :href="logoLink" class="logo" :class="{ rent: page.indexOf('rent') > -1 }">Jodi</a> -->
        <!-- <span>Find your Dream Home</span>-->
        <!-- <a href="/buy" :class="{ 'is-active': routeName === 'buy' }">{{ $t('Buy') }}</a>
        <a href="/rent" :class="{ 'is-active': routeName === 'rent' }">{{ $t('Rent') }}</a>-->
      </div>
      <div class="header-inner--center">
        <a href="/" class="logo" :class="{ rent: page.indexOf('rent') > -1 }">Jodi</a>
      </div>
      <div class="header-inner--right">
        <a href="/sell/listing" :class="{ active: active === 'buy' }">Sell</a>
        <a href="/rent/listing" :class="{ active: active === 'rent' }">Rent</a>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    logoLink: String,
    page: { type: String, default: '' },
  },
  computed: {
    active() {
      return this.$route.name
    },
  },
}

</script>
<style lang="less" scoped>
@import url('../assets/less/var.less');

.header {
  position: relative;
  background: #fff;
  height: @common-header-height;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  z-index: 9;
}

.header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: @main-content-width;
  max-width: 100%;
  height: @common-header-height;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.5);
  font-size: 14px;

  .header-inner--left a {
    color: rgba(0, 0, 0, 0.5);
    text-decoration: none;
    margin-right: 26px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  .header-inner--center {
    .logo {
      display: inline-block;
      text-indent: -999em;
      height: 50px;
      width:72px;
      background-image: url('../assets/images/logo-color.png');
      background-size: cover;
      background-position: center;
      // background-size: 100%;
    }

    .logo.rent {
      background-image: url('../assets/images/rental.png');
      height: 48px;
      width: 92px;
    }

    span {
      vertical-align: middle;
    }
  }

  .header-inner--right a {
    color: rgba(0, 0, 0, 0.5);
    text-decoration: none;
    margin-right: 26px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  .active {
    color: #9ecf40 !important;
  }
}

@media (max-width: 767px) {
  .header-inner {
    width: 100%;
    padding: 0 14px;
    box-sizing: border-box;

    .header-inner--left,
    .header-inner--right {
      min-width: 82px;
    }

    .header-inner--left a,
    .header-inner--right a {
      margin-right: 14px;
      font-size: 13px;
    }

    .header-inner--right {
      text-align: right;
    }

    .header-inner--center {
      .logo {
        width: 62px;
        height: 43px;
      }

      .logo.rent {
        width: 82px;
        height: 43px;
      }
    }
  }
}
</style>
